<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { SHEET_GROUPS } from '../composables/commissionSheetForm';
import RealEstateCommissionSheetPreviewFooter from './RealEstateCommissionSheetPreviewFooter.vue';
import RealEstateCommissionSheetPreviewRow from './RealEstateCommissionSheetPreviewRow.vue';

const props = defineProps({
  amountCents: { type: Number, default: 0 },
  form: { type: Object, required: true },
  totals: { type: Object, required: true },
});

const { t } = useI18n();
const rows = computed(() =>
  SHEET_GROUPS.flatMap(group =>
    (props.form[group] || []).map((row, index) => ({ ...row, group, index }))
  ).filter(
    row => Number(String(row.porcentagem_real || 0).replace(',', '.')) > 0
  )
);
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.TABLE_TITLE')"
    prefix-icon="i-lucide-table-properties"
    density="flush"
  >
    <div class="overflow-x-auto">
      <table class="w-full min-w-[950px] text-left text-sm">
        <thead
          class="bg-lais-bg-soft text-xs uppercase tracking-wide text-lais-text-muted"
        >
          <tr>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.ROLE') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.COMMISSION') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.DIFFERENCE') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.RECEIVABLE') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.NAME') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.DOCUMENT') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.CRECI') }}
            </th>
            <th class="px-4 py-3">
              {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.PAYMENT') }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-lais-border-soft">
          <RealEstateCommissionSheetPreviewRow
            v-for="row in rows"
            :key="`${row.group}-${row.index}`"
            :amount-cents="amountCents"
            :row="row"
          />
        </tbody>
        <RealEstateCommissionSheetPreviewFooter
          :amount-cents="amountCents"
          :totals="totals"
        />
      </table>
    </div>
  </LaisCard>
</template>
